import featureFlags from "@/constants/feature-flags";
import { components } from "@/lib/openapi/schemas/service-telegram-authorization";
import useFeatureFlags from "./use-feature-flags";

const useFeatureFlag = (
  featureFlag: keyof typeof featureFlags,
  {
    user,
    onSuccess,
    onError,
  }: {
    user?: components["schemas"]["UserResponse"];
    onSuccess?: (newData: boolean) => void;
    onError?: (error: Error) => void;
  } = {},
) => {
  const {
    featureFlags,
    set: setFeatureFlags,
    setAsync: setFeatureFlagsAsync,
    isPending,
  } = useFeatureFlags({
    user,
    onSuccess: (featureFlags) => {
      onSuccess?.(featureFlags.includes(featureFlag));
    },
    onError,
  });

  const set = (newData: boolean) => {
    if (newData === featureFlags.includes(featureFlag)) return;

    setFeatureFlags(
      featureFlags.includes(featureFlag)
        ? featureFlags.filter((flag) => flag !== featureFlag)
        : [...featureFlags, featureFlag],
    );
  };

  const setAsync = async (newData: boolean) => {
    if (newData === featureFlags.includes(featureFlag)) return;

    return (
      await setFeatureFlagsAsync(
        featureFlags.includes(featureFlag)
          ? featureFlags.filter((flag) => flag !== featureFlag)
          : [...featureFlags, featureFlag],
      )
    ).includes(featureFlag);
  };

  return {
    featureFlag: featureFlags.includes(featureFlag),
    set,
    setAsync,
    isPending,
  };
};

export default useFeatureFlag;
